import { defineStore } from 'pinia'
import { useCostCenterStore } from "@/stores/costCenter"
import { InvoiceStepFilterEnum } from "@/enums"
import { dateAddMonth } from "@/mega-ui/helpers/function"

interface IDateFilterState {
    startDate: Date|null,
    endDate: Date|null
}

export const useDateFilterConsumptionStore = defineStore('dateFilterConsumptionStore', {
    state: () : IDateFilterState => ({
        startDate: null,
        endDate: null
    }),
    actions: {
        setStartDate(date: Date) {
            this.startDate = date;
        },
        setEndDate(date: Date) {
            this.endDate = date;
        },
        currentDateInvoiceFilter() {
            const costCenterStore = useCostCenterStore()
            this.startDate = costCenterStore.billCycleStartDate ?? dateAddMonth(new Date, 1, '-');
            this.endDate = costCenterStore.billCycleEndDate ?? new Date();
        },
        previousDateInvoiceFilter() {
            const costCenterStore = useCostCenterStore()
            this.startDate = costCenterStore.billCycleStartDate ?? dateAddMonth(new Date, 1, '-');
            this.endDate = costCenterStore.billCycleEndDate ?? new Date();
            this.startDate = new Date(new Date(this.startDate).setMonth(this.startDate.getMonth() - 1));
            this.endDate = new Date(new Date(this.endDate).setMonth(this.endDate.getMonth() - 1));
        },
        resetFilters() {
            this.startDate = dateAddMonth(new Date, 1, '-');
            this.endDate = new Date();
        },
    },
    getters: {
        getStartDate(state: IDateFilterState) {
            if (!state.startDate) {
                const costCenterStore = useCostCenterStore()
                return costCenterStore.billCycleStartDate ?? dateAddMonth(new Date, 1, '-')
            }

            return state.startDate
        },
        getEndDate(state: IDateFilterState) {
            if (!state.endDate) {
                const costCenterStore = useCostCenterStore()
                return costCenterStore.billCycleEndDate ?? new Date()
            }

            return state.endDate
        }
    }
});

interface IFilterState {
    filter: InvoiceStepFilterEnum
}

export const useFilterConsumptionStore = defineStore('filterConsumptionStore', {
    state: () : IFilterState => ({
        filter: InvoiceStepFilterEnum.CURRENT_INVOICE,
    }),
    actions: {
        setFilter(filter: InvoiceStepFilterEnum) {
            this.filter = filter;
        },
        resetFilter() {
            this.filter =  InvoiceStepFilterEnum.CURRENT_INVOICE;
        },
    },
    getters: {
        currentStep(state: IFilterState): InvoiceStepFilterEnum {
            return state.filter
        }
    }
});
